import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import { Amplify } from "aws-amplify";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBUp8E7OghfEFg9fJ1ePokoOhE1I8MaD-M",
    libraries: "places",
  },
});

Amplify.configure({
  Auth: {
    userPoolId: "us-east-1_YaOnliZGn",
    // userPoolId: "us-east-1_dZzFC5cc7",
    region: "us-east-1",
    userPoolWebClientId: "1veingm14nj3sued1f21g44arh",
    // userPoolWebClientId: "ujn6q4h4okucd66biqb40u1p",
  },
  API: {
    aws_project_region: "us-east-1",
    aws_appsync_graphqlEndpoint:
      "https://h2b7tqcdibfztc7yuazfp7zynm.appsync-api.us-east-1.amazonaws.com/graphql",
    aws_appsync_region: "us-east-1",
    aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
    aws_appsync_apiKey: "da2-gcxftqv7g5ggvofttayc2zaxje",
    endpoints: [
      {
        name: "MAKEITHOMESAFE",
        endpoint:
          "https://m4yvvvbv90.execute-api.us-east-1.amazonaws.com/prod/",
      },
    ],
  },
});

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
